import CaseStatusUpdateActivity from './CaseStatusUpdateActivity';

export default CaseStatusUpdateActivity;
